'use client';

import { useRouter } from 'next/navigation';
import { ArrowLeftIcon } from 'lucide-react';

import { navigateBlogPreferredBack } from '@/app/(backButtonHeader)/blog/_components/BlogNavStack';

export function BlogStickyBackButton() {
  const router = useRouter();

  return (
    <button
      type='button'
      onClick={() => navigateBlogPreferredBack(router)}
      className='text-foreground transition-opacity duration-300 hover:opacity-90 hover:text-accent'
      aria-label='Go to previous page or blog'
    >
      <ArrowLeftIcon className='w-6 h-6' aria-hidden />
    </button>
  );
}
